// extracted by mini-css-extract-plugin
export default {"BetaLabel":"IntegerField-module__BetaLabel--Ppvqg"};